import Vue from "vue"
import Component from "vue-class-component"

@Component
export default class FrontUrlMixin extends Vue {
  public get frontOrigin(): string {
    const scheme = process.env.VUE_APP_PREVIEW_SCHEME
    const host = process.env.VUE_APP_PREVIEW_HOST
    const port = process.env.VUE_APP_PREVIEW_PORT || 80
    return `${scheme}://${host}:${port}`
  }

  public articlesShelfStoryUrl(id: number): string {
    return `${this.frontOrigin}/articles/shelf_story/${id}`
  }
}
